module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-144x144-d86902dba82250990f058416aa5f13ae.png";